<template>
    <div>
        <button class="btn btn-default btn-xs" @click="showDialog = true">
            <span class="fa fa-plus"></span>
            Add Product Note/Ban
        </button>

        <ProductBanDialog
            v-if="showDialog"
            :productId="productId"
            @hide="showDialog = false"
            @saved="saved"
            />
    </div>
</template>

<script>
export default {
    components: {
        ProductBanDialog: require('./ProductBanDialog.vue').default,
    },
    props: {
        productId: { required: true },
    },
    data() {
        return {
            showDialog: false,
        };
    },
    methods: {
        saved() {
            this.showDialog = false;

            // Quick hack to reload vendor inventory page data
            let handler = this.$route.matched[0].instances.default.updateData;
            if (handler) {
                handler();
            }
        },
    }
}
</script>

